/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Rv_Pros_3Inputs */

const en_pc_rv_pros_3 = /** @type {(inputs: Pc_Rv_Pros_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reads and writes layered PSD and PSB`)
};

const zh_pc_rv_pros_3 = /** @type {(inputs: Pc_Rv_Pros_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`能读写分层 PSD 和 PSB`)
};

/**
* | output |
* | --- |
* | "Reads and writes layered PSD and PSB" |
*
* @param {Pc_Rv_Pros_3Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_rv_pros_3 = /** @type {((inputs?: Pc_Rv_Pros_3Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Rv_Pros_3Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_rv_pros_3(inputs)
	return zh_pc_rv_pros_3(inputs)
});
export { pc_rv_pros_3 as "pc.rv.pros.3" }